import { render, staticRenderFns } from "./pageLoading.vue?vue&type=template&id=a36f430a&scoped=true"
import script from "./pageLoading.vue?vue&type=script&lang=js"
export * from "./pageLoading.vue?vue&type=script&lang=js"
import style0 from "./pageLoading.vue?vue&type=style&index=0&id=a36f430a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36f430a",
  null
  
)

export default component.exports